import dayjs from "dayjs";

import { useAppDispatch } from "@/store/hooks";
import { fetchScheduleAppointmentList } from "@/store/slices/doctor/schedule";

const useAppointmentDateFilter = () => {
  const dispatch = useAppDispatch();

  const applyDateRangeValues = (startDate: string, endDate: string) => {
    const filterOptions = {
      start: startDate,
      end: dayjs(endDate).add(1, "day").format("YYYY-MM-DD"),
    };
    dispatch(
      fetchScheduleAppointmentList(
        startDate && endDate
          ? {
              start: startDate,
              end: dayjs(endDate).add(1, "day").format("YYYY-MM-DD"),
            }
          : filterOptions
      )
    );
  };

  return { applyDateRangeValues };
};

export default useAppointmentDateFilter;
